import { BaseConfig } from '../ServiceConfig';

export interface WordPressConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.WordPressServiceConfigData';
  url: string;
}

export const WordPressConfigurationFields: (keyof WordPressConfiguration)[] = [
  'url',
];

export const BlankWordPressConfiguration: WordPressConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.WordPressServiceConfigData',
} as WordPressConfiguration;
